import React, { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../utils/code";
import { toast } from "react-toastify";

const FileUploadPopup = ({ fileUploadOpen, onClose, onSuccess, id }) => {
  const [selectedFiles, setSelectedFiles] = useState({
    file: null,
    image2: null,
    image3: null,
  });
  const [error, setError] = useState({});

  const handleClosePopup = () => onClose();

  const fieldLabels = {
    image2: "Upload bottom left side image",
    image3: "Upload bottom center image",
    file: "Upload bottom right side image",
  };

  const isValidate = (file, field) => {
    const maxFileSize = 100 * 1024; // 100 KB
    const allowedFileType = "image/png";

    if (file.type !== allowedFileType) {
      setError((prev) => ({
        ...prev,
        [field]: "Only .png files are allowed.",
      }));
      return false;
    }

    if (file.size > maxFileSize) {
      setError((prev) => ({
        ...prev,
        [field]: "File size exceeds 100 KB.",
      }));
      return false;
    }

    setError((prev) => ({ ...prev, [field]: "" }));
    return true;
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (!file) return;

    if (isValidate(file, field)) {
      setSelectedFiles((prev) => ({ ...prev, [field]: file }));
    } else {
      setSelectedFiles((prev) => ({ ...prev, [field]: null }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    let hasFile = false;

    for (const key in selectedFiles) {
      const file = selectedFiles[key];
      if (file) {
        formData.append(key, file);
        hasFile = true;
      }
    }

    if (!hasFile) {
      toast.warning("Please select at least one file to upload.");
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/api/projects/upload-touch-image/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.message) {
        onSuccess(response?.data?.uploadedFiles);
        handleClosePopup();
        toast.success(response.data.message);
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("File upload failed.");
    }
  };

  return (
    <div className="fixed inset-0 flex justify-center items-center z-50">
      {fileUploadOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-10"
          onClick={handleClosePopup}
        ></div>
      )}
      {fileUploadOpen && (
        <div className="fixed flex items-center justify-center z-20">
          <div className="bg-white rounded-lg shadow-lg p-6 w-[500px]">
            <h2 className="text-xl font-bold mb-4">Upload Files</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              {["image2", "image3", "file"].map((field) => (
                <div key={field}>
                  <label
                    htmlFor={field}
                    className="block text-gray-700 font-medium mb-2"
                  >
                    {fieldLabels[field]}:
                  </label>
                  <input
                    type="file"
                    id={field}
                    className="block w-full border border-gray-300 rounded-md p-2"
                    accept="image/png"
                    onChange={(e) => handleFileChange(e, field)}
                  />
                  {error[field] && (
                    <p className="text-red-500 text-sm">{error[field]}</p>
                  )}
                </div>
              ))}

              <p className="text-yellow-500 text-sm">
                The "LOGO" should be a deep black color with no background.
              </p>

              <div className="flex justify-end space-x-2">
                <button
                  type="button"
                  onClick={handleClosePopup}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                >
                  Upload
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUploadPopup;
